/**
 * início's four suggestion cards (Figma `LrdQopN1jNWKJFWxOkn0IY` node
 * `362:14912`): fixed product copy, not derived from what the campaign
 * collected -- AS-1's wire contract carries no per-campaign suggestion list,
 * so these read the same for every campaign. The frame's own examples
 * ("Benedito Bentes", "o viaduto") are that mock campaign's data, not
 * drawable copy, so the territory question is worded generically instead of
 * repeating them. Own catalogue, not `messages.ts`'s: this key set belongs
 * to `Suggestions.tsx` alone.
 */

import { defineCatalogue } from '../../../i18n';

const pt = {
  'pautas.category': 'Pautas',
  'pautas.question': 'Qual pauta rendeu mais esta semana?',
  'amplification.category': 'Amplificação',
  'amplification.question': 'Quem levou adiante a última publicação?',
  'territory.category': 'Território',
  'territory.question': 'Qual bairro reagiu mais à pauta da semana?',
  'accounts.category': 'Contas',
  'accounts.question': 'Quais contas aliadas pararam de publicar?',
} satisfies Record<string, string>;

export type SuggestionMessageKey = keyof typeof pt;

export const suggestionCatalogue = defineCatalogue(pt, {
  'pautas.category': 'Topics',
  'pautas.question': 'Which topic reached the most this week?',
  'amplification.category': 'Amplification',
  'amplification.question': 'Who carried the last post forward?',
  'territory.category': 'Territory',
  'territory.question': 'Which neighbourhood reacted most to this week’s topic?',
  'accounts.category': 'Accounts',
  'accounts.question': 'Which allied accounts stopped posting?',
});

export const st = suggestionCatalogue.t;
